<template>
  <Navbar />
  <div class="content-wrapper">
    <div v-if="loading">
      <Loader />
    </div>
    <div class="main-content" v-else>
      <section class="pt-50 pb-60  overflow-hidden">
        <div class="container">
          <div class="row">
            <!----Blogs Content----------->
            <div class="col-lg-8 mb-30" data-aos="fade-up" :data-aos-delay="200">
              <div class="row y-gap-30">
                <div v-for="(blog, i) in blogArray" :key="blog.id">
                  <!------Top Card------------>
                  <div class="col-lg-12 col-md-12" v-if="i === 0">
                    <router-link :to="{ name: 'single-blog', params: { id: blog.slug } }" class="blogCard -type-1">
                      <div class="blogCard__image" style="width: 100%;height: 470px;">
                        <img class="w-1/1 rounded-8" :src="blog?.cover" :alt="blog?.title"
                          style="object-fit: cover; width: 100%;height: 100%;" />
                      </div>
                      <div class="blogCard__content-first mt-20">
                        <h4 class="blogCard__title text-32 mb-15">
                          {{ blog?.title }}
                        </h4>

                        <div class="d-flex align-items-center blog-owner">
                          <div class="blogCard__category d-flex justify-center align-items-center rounded-full">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20"
                              fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M9.00146 2.32039C7.32658 2.32039 5.96883 3.67814 5.96883 5.35301C5.96883 7.02787 7.32658 8.38562 9.00146 8.38562C10.6763 8.38562 12.0341 7.02787 12.0341 5.35301C12.0341 3.67814 10.6763 2.32039 9.00146 2.32039ZM4.48242 5.35301C4.48242 2.85722 6.50567 0.833984 9.00146 0.833984C11.4973 0.833984 13.5205 2.85722 13.5205 5.35301C13.5205 7.84879 11.4973 9.87203 9.00146 9.87203C6.50567 9.87203 4.48242 7.84879 4.48242 5.35301Z"
                                fill="#94AD04" />
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M3.33248 12.9313C4.69064 12.1206 6.52819 11.5806 9.00157 11.5806C11.4749 11.5806 13.3125 12.1206 14.6707 12.9313C16.0294 13.7424 16.8649 14.7984 17.374 15.7622L17.374 15.7623C17.8295 16.6249 17.6805 17.5199 17.1634 18.1691C16.6661 18.7936 15.8567 19.1664 14.9877 19.1664H3.01542C2.14646 19.1664 1.33699 18.7936 0.839673 18.1691C0.322636 17.5198 0.17361 16.6249 0.629184 15.7623C1.1382 14.7985 1.97374 13.7424 3.33248 12.9313ZM4.09434 14.2076C3.00486 14.8579 2.34588 15.6946 1.94355 16.4564L1.94354 16.4564C1.77957 16.7669 1.83173 17.0288 2.00244 17.2432C2.19287 17.4823 2.5577 17.68 3.01542 17.68H14.9877C15.4454 17.68 15.8102 17.4823 16.0007 17.2432C16.1714 17.0288 16.2236 16.7669 16.0596 16.4564C15.6573 15.6946 14.9983 14.8579 13.9088 14.2076C12.8187 13.5569 11.2544 13.067 9.00157 13.067C6.74877 13.067 5.1844 13.5569 4.09434 14.2076Z"
                                fill="#94AD04" />
                            </svg>
                          </div>
                          <div>
                            <h4 class="blogCard__title text-16 lh-15 fw-500">
                              {{ blog?.author?.name }}
                            </h4>
                            <div class="blogCard__date mt-5 text-16">{{ blog?.date }}</div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                  <!----------Next 4 components------------->

                  <div class="col-md-6" v-else>
                    <router-link :to="{ name: 'single-blog', params: { id: blog.slug } }" class="blogCard -type-1">
                      <div class="blogCard__image" style="height: 300px;">
                        <img class="w-1/1 rounded-8 object-fit-cover" :src="blog?.cover" :alt="blog?.title"/>
                      </div>
                      <div class="blogCard__content mt-20">
                        <div class="blogCard__category">{{ blog?.title }}</div>
                          <p>{{ getPreview(blog?.content, 100) }}</p>
                        <!-- <div v-html="blog?.content"></div> -->
                        <h4 class="blogCard__title text-18 lh-15 fw-500 mt-5">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                            fill="none">
                            <path
                              d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                              stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                            <path
                              d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                              stroke="#94AD04" stroke-width="1.5" />
                          </svg>
                          {{ blog?.author?.name }}
                        </h4>
                        <div class="blogCard__date mt-5">{{ blog?.date }}</div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-------start of pagination section--------->
                <div>
                  <PaginationComponent v-model:currentPage="currentPage" :lastPage="totalPages" :maxVisiblePages="1"
                    @update:currentPage="handlePageChange" />
                  <!----<div>Currently on Page: {{ currentPage }}</div>-->
                </div>
                <!-------end of navigation--------->
              </div>
            </div>
            <!------Blogs side bar------>
            <div class="col-lg-4" data-aos="fade-up" :data-aos-delay="250">
              <Sidebar :relatedPosts="blogArray" />
            </div>
          </div>
        </div>
      </section>
    </div>
    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
// import BlogsContent from "@/components/Blogs/BlogsContent.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import Sidebar from "@/components/Blogs/Sidebar.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
import { getLatestCourses } from "@/Services/api/CoursesService";
import PaginationComponent from "@/components/common/PaginationComponent.vue";
import { getBlogs } from "@/Services/api/Blogs";
import Loader from "@/components/common/Loader.vue";
export default {
  components: {
    Navbar,
    // BlogsContent,
    FooterItem,
    Sidebar,
    PaginationComponent,
    Loader
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  data() {
    return {
      blogArray: [],
      currentPage: 1,
      totalItems: 0,
      perPage: 10,
      totalPages: 0,
      loading: false
    };
  },
  methods: {
    //recent courses
    async getRecentCourse() {
      try {
        const response = await getLatestCourses();
        this.latestCourses = response.data;
      } catch (error) {
        console.log(error.message)
      }
    },
    // get Blogs Content 
    async fetchBlogs() {
      this.loading = true
      try {
        const response = await getBlogs(1);
        this.blogArray = response.data.posts.data;
        // console.log("blog array", this.blogArray);
        // console.log(response)
        // pagination
        this.currentPage = response.data.posts.meta.current_page || 1;
        this.totalItems = response.data.posts.meta.total;
        this.perPage = response.data.posts.meta.per_page;
        this.totalPages = Math.ceil(this.totalItems / this.perPage);
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false
      }
    },
    handlePageChange(newPage) {
      this.currentPage = newPage;
     this.fetchBlogs();
    },
      // remove HTML tags and return plain text
    stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    // return preview text (e.g., first 150 chars)
    getPreview(content, length = 150) {
      if (!content) return '';
      return this.stripHtml(content).slice(0, length) + '...';
    },
    //Meta tags
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "المدونة - Planning Force | مقالات ونصائح للتعلم الإلكتروني"
          : "Blogs - Planning Force | Articles and Tips for e-Learning";

      const description =
        this.currentLanguage === "ar"
          ? "استكشف أحدث المقالات والنصائح حول التعلم الإلكتروني، تطوير المهارات، والنمو الشخصي على منصة Planning Force."
          : "Explore the latest articles and tips on e-learning, skill development, and personal growth on the Planning Force platform.";

      const keywords =
        this.currentLanguage === "ar"
          ? "مدونة, Planning Force, مقالات, نصائح, تعلم إلكتروني, تطوير المهارات"
          : "blog, Planning Force, articles, tips, e-learning, skill development";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/blog-og-image.jpg",
          }, // Replace with your blogs page image URL
          { property: "og:url", content: "https://example.com/blogs" }, // Replace with your blogs page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/blog-twitter-image.jpg",
          }, // Replace with your blogs page image URL
        ],
      });
    },
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
        this.getRecentCourse();
        this.fetchBlogs();
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
